import i18n from 'i18next'

import { userManager } from '@/Core/Managers'

import { DepartmentFormTemplate } from '../Templates/DepartmentFormTemplate'

export const DepartmentResource = {
    title: i18n.t('Company structure', { ns: 'Setting.Department' }),
    fields: {
        isActive: {
            label: i18n.t('Active', { ns: 'Setting.Department' }),
            type: 'switch',
            defaultValue: true,
        },
        title: {
            label: i18n.t('Name', { ns: 'Setting.Department' }),
            isRequired: true,
        },
        code: {
            label: i18n.t('Code', { ns: 'Setting.Department' }),
            isRequired: true,
        },
        parent: {
            label: i18n.t('Department', { ns: 'Setting.Department' }),
            type: 'select',
            resource: 'Company.Department',
        },
        chiefs: {
            label: i18n.t('Heads', { ns: 'Setting.Department' }),
            type: 'select',
            isMultiple: true,
            resource: 'Setting.User',
        },
        users: {
            label: i18n.t('Users', { ns: 'Setting.Department' }),
            type: 'select',
            isMultiple: true,
            resource: 'Setting.User',
        },
    },
    form: {
        template: DepartmentFormTemplate,
    },
    restUrl: '/core_api/departments',
    accessFn: (mode: string): boolean => {
        const roles: string[] = userManager.user?.roles ?? []
        const isPrivileged = roles.includes('ROLE_ADMIN') || roles.includes('ROLE_SUPER_USER')

        const rules: Record<string, boolean> = {
            create: isPrivileged,
            read: true,
            update: isPrivileged,
            delete: isPrivileged,
        }

        return rules[mode] ?? false
    },
}
